import { defineMessages } from 'react-intl';

export const actionResultPageMessages = defineMessages({
  forgotPasswordSent: {
    id: 'auth.action-result-page.forgot-password-sent',
    defaultMessage:
      'Please check your email to complete your password reset. If you’re having trouble, please contact <a>Partner Success</a>.',
  },
  userNotFound: {
    id: 'auth.action-result-page.user-not-found',
    defaultMessage:
      'There is no account associated with this email address. If you need access, please contact <a>Partner Success</a>.',
  },
  userIsInactive: {
    id: 'auth.action-result-page.user-is-inactive',
    defaultMessage:
      'The account associated with this email address has been deactivated. If you need access, please contact <a>Partner Success</a>.',
  },
  back: {
    id: 'auth.action-result-page.back',
    defaultMessage: 'Back to login',
  },
});

export const authSagaMessages = defineMessages({
  invalidCreds: {
    id: 'auth.saga.do-user-login.error',
    defaultMessage: 'Invalid email or password',
  },
  processing: {
    id: 'auth.saga.do-user-forgot-password.error',
    defaultMessage: 'There was a problem processing your request.',
  },
  resetExpired: {
    id: 'auth.saga.do-user-reset-password.error',
    defaultMessage: 'This Reset password link has expired.',
  },
  logOut: {
    id: 'auth.saga.handle-logout-route-enter.error',
    defaultMessage: 'There was a problem logging you out.  Please try again.',
  },
});

export const forgotPasswordFormMessages = defineMessages({
  title: {
    id: 'auth.forgot-password-form.title',
    defaultMessage: 'Reset your password',
  },
  email: {
    id: 'auth.forgot-password-form.email',
    defaultMessage: 'Email',
  },
  submit: {
    id: 'auth.forgot-password-form.submit',
    defaultMessage: 'Submit',
  },
  back: {
    id: 'auth.forgot-password-form.back',
    defaultMessage: 'Back to login',
  },
});

export const validationMessages = defineMessages({
  invalidEmail: {
    id: 'auth.validation.invalid-email',
    defaultMessage: 'Please enter a valid email address',
  },
  passwordMismatch: {
    id: 'auth.validation.password-mismatch',
    defaultMessage: 'Passwords need to match',
  },
  passwordLength: {
    id: 'auth.validation.password-length',
    defaultMessage: 'Passwords must be between 6-25 characters',
  },
});

export const loginFormMessages = defineMessages({
  signIn: {
    id: 'auth.login-form.sign-in',
    defaultMessage: 'Sign in to your account',
  },
  logIn: {
    id: 'auth.login-form.log-in',
    defaultMessage: 'Log in',
  },
  resetPassword: {
    id: 'auth.login-form.reset-password',
    defaultMessage: 'Reset password',
  },
  noLogin: {
    id: 'auth.login-form.no-login',
    defaultMessage: 'Sign-Up',
  },
  support: {
    id: 'auth.login-form.support',
    defaultMessage: 'Support',
  },
  email: {
    id: 'auth.login-form.email',
    defaultMessage: 'Email',
  },
  password: {
    id: 'auth.login-form.password',
    defaultMessage: 'Password',
  },
  loginFailed: {
    id: 'auth.login-form.login-failed',
    defaultMessage: 'There was a problem logging you in.  Please try again.',
  },
  legalText: {
    id: 'auth.login-form.legal-text',
    defaultMessage:
      'By clicking below, you agree to the <terms>Terms of Use</terms> and acknowledge the <privacy-policy>Privacy Policy</privacy-policy>.',
  },
});

export const resetPasswordFormMessages = defineMessages({
  title: {
    id: 'auth.reset-password-form.title',
    defaultMessage: 'Reset password',
  },
  hint: {
    id: 'auth.reset-password-form.hint',
    defaultMessage: 'Passwords must be between 6-25 characters',
  },
  newPassword: {
    id: 'auth.reset-password-form.new-password',
    defaultMessage: 'New Password',
  },
  confirmPassword: {
    id: 'auth.reset-password-form.confirm-password',
    defaultMessage: 'Confirm Password',
  },
  submit: {
    id: 'auth.reset-password-form.submit',
    defaultMessage: 'Submit',
  },
});

export const mfaFormMessages = defineMessages({
  title: {
    id: 'auth.mfa-form.title',
    defaultMessage: 'Multi-factor authentication',
  },
  subtitle: {
    id: 'auth.mfa-form.subtitle',
    defaultMessage: 'Enter the code from your MFA authentication app',
  },
  otpPlaceholder: {
    id: 'auth.mfa.otpPlaceholder',
    defaultMessage: '______',
  },
  recoverHint: {
    id: 'auth.mfa-form.recover-hint',
    defaultMessage:
      'Trouble accessing your verification code? Use a saved <button>recovery backup code</button> instead.',
  },
  backToLogin: {
    id: 'auth.mfa-form.back',
    defaultMessage: 'Back to Sign in',
  },
  support: {
    id: 'auth.mfa-form.support',
    defaultMessage: 'Support',
  },
  codeNotValid: {
    id: 'auth.mfa-form.code-not-valid',
    defaultMessage: 'The code you entered is not valid. Please try again.',
  },
  accountRecovery: {
    id: 'auth.mfa-form.account-recovery',
    defaultMessage: 'Account recovery',
  },
  accountRecoverySubtitle: {
    id: 'auth.mfa-form.account-recovery-subtitle',
    defaultMessage: 'Recover your account by entering one of the recovery codes provided to you during MFA set up.',
  },
  recoveryTextPlaceholder: {
    id: 'auth.mfa-form.recovery-text-placeholder',
    defaultMessage: '_____-_____',
  },
  verify: {
    id: 'auth.mfa-form.verify',
    defaultMessage: 'Verify',
  },
  recoveryCodeNotValid: {
    id: 'auth.mfa-form.recovery-code-not-valid',
    defaultMessage: 'The recovery code you entered is not valid. Please try again.',
  },
});
